'use client';

import React, { useCallback } from 'react';
import { ChevronDown, Menu } from 'lucide-react';
import { settleStrobe, startStrobe, strobeOnHover } from '@/components/ui/nav-strobe';

interface CatalogMenuProps {
  className?: string;
  onToggle?: () => void;
  isOpen?: boolean;
  isActive?: boolean;
  isMobile?: boolean;
  label?: string;
  isLeft?: boolean;
}

export function CatalogMenu({
  className,
  onToggle,
  isOpen = false,
  isActive = false,
  isMobile = false,
  label = 'CATALOG RAISONNE',
  isLeft = false
}: CatalogMenuProps) {
  const handleToggle = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      // Prevent event bubbling
      e.stopPropagation();
      e.preventDefault();
      // The button of an open menu rests; closing it under the pointer strobes again
      if (!isOpen) {
        settleStrobe(e.currentTarget);
      } else if (e.currentTarget.matches(':hover')) {
        startStrobe(e.currentTarget);
      }
      if (onToggle) {
        onToggle();
      }
    },
    [onToggle, isOpen]
  );

  return (
    <button
      className={`nav-button nav-strobe inline-flex items-center ${isActive ? 'nav-strobe-active' : ''} ${className || ''} ${isOpen ? 'text-zinc-400 bg-zinc-900' : ''}`}
      onClick={handleToggle}
      data-catalog-button
      aria-expanded={isOpen}
      {...strobeOnHover}
      style={{
        paddingInline: isMobile ? 'calc(var(--spacing)* 1)' : 'calc(var(--spacing)* 2)',
      }}
    >
      {!isMobile && (
        <div className={'inline-flex items-center gap-1' + (isLeft ? ' flex-row-reverse' : '')}>
          <span>{label}</span>
          <ChevronDown
            size={14}
            className={`transition-transform duration-300 ease-in-out ${isOpen ? 'rotate-180' : ''}`}
          />
        </div>
      )}
      {isMobile && (
        <>
          <Menu size={14} className={`transition-transform duration-300 ease-in-out ${isOpen ? 'rotate-180' : ''}`} />
        </>
      )}
    </button>
  );
}
